import type { ReactNode } from "react";
import { useRef, useState } from "react";
import "./DatePicker.scss";
import PopMenu from "@/shared/components/generic/pop-menu/PopMenu";
import DateDisplay from "@/shared/components/generic/date/date-navigator/date-picker/date-display/DateDisplay";
import type { DateTime } from "luxon";
import DayCalendar from "@/shared/components/generic/date/DayCalendar";

interface Properties {
  timeZone: string;
  value: DateTime;
  onChange: (d: DateTime) => void;
}

export default function DatePicker(props: Properties): ReactNode {
  const [calendarOpen, setCalendarOpen] = useState(false);
  const anchorEl = useRef<HTMLDivElement>(null);
  return (
    <div className="date-picker" ref={anchorEl}>
      <DateDisplay
        value={props.value}
        timeZone={props.timeZone}
        onClick={() => {
          setCalendarOpen((h) => !h);
        }}
      />
      <PopMenu
        open={calendarOpen}
        anchorEl={anchorEl.current}
        onClose={() => {
          setCalendarOpen(false);
        }}
        placement={"bottom"}
      >
        <DayCalendar
          date={props.value}
          timeZone={props.timeZone}
          onDateChanged={props.onChange}
          onDateSet={() => {
            setCalendarOpen(false);
          }}
        />
      </PopMenu>
    </div>
  );
}
